import React from 'react'
import ProductSearch from '../components/ProductSearch/ProductSearch'
import { useCustomerDisplay } from '../context/CustomerDisplayContext'

export default function ProductSearchPage() {
  const { listProducts, isLoadingProductSearch } = useCustomerDisplay()

  return (
    <ProductSearch
      listProducts={listProducts}
      isLoading={isLoadingProductSearch}
    />
  )
}
